import { FormattedMessage } from 'react-intl';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { useSellerFormattedDate } from '../../../../../../hooks/use-datetime-formats';

import { messages } from '../messages';

const CreateDateColumn = ({ row }) => {
  const { createDateUtc } = row.original;
  const displayDate = useSellerFormattedDate(createDateUtc);

  return (
    <FlexColumn>
      <Text textType={TextType.Paragraph} value={displayDate} />
    </FlexColumn>
  );
};

export const createCreateDateColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'createDateUtc',
  Header: (
    <div>
      <FormattedMessage {...messages.columnCreateDate} />
    </div>
  ),
  Cell: CreateDateColumn,
  width: 2,
});
